import * as io from "io-ts";
import createGlobalState from "@ui/lib/createGlobalState";

const TabType = io.keyof({
  comments: null,
  activity: null,
});

export const useSidePanelTab = createGlobalState({
  storage: "session",
  key: "sidePanelTab",
  type: TabType,
  defaultValue: "comments",
  scoped: true,
});

export const useSidePanelOpened = createGlobalState({
  storage: "session",
  key: "sidePanelOpened",
  type: io.boolean,
  defaultValue: false,
  scoped: true,
});
